<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="region-retailers-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header-container">
                        <h2
                            class="title"
                            v-test:title
                        >
                            {{ title }}
                        </h2>
                        <markdown-content
                            v-if="intro"
                            class="intro"
                            :content="intro"
                            v-test:intro
                        />
                    </div>

                    <retailer-logos
                        :retailers="retailers"
                    />
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import RetailerLogos from '../../molecules/RetailerLogos/RetailerLogos.vue';

    export default {
        name: 'region-retailers-section',

        components: { RetailerLogos, MarkdownContent },

        props: {
            title: {
                type: String,
                required: true,
                default: '',
            },

            intro: {
                type: String,
                default: '',
            },

            retailers: {
                type: Array,
                required: true,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .region-retailers-section {
        padding: 40px 0;
        text-align: center;
        font-size: rem(20px);
        line-height: 1.33;
    }

    .title {
        margin-bottom: 25px;
        font-weight: bold;
    }

    .intro {
        text-wrap: balance;
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
        color: #4a4a49;
    }

    .mobile-gutter {
        @include media-breakpoint-up(sm) {
            padding: 0;
        }
    }

    .retailer-logos {
        max-width: 720px;
        margin: 0 auto;
    }
</style>
